<template>
  <div class="page bodyd">
    <div class="container-fluid pop-blog">
    <div class="row">
    <div class="col text-center">
      <img
                  src="../assets/images/logo2.png"
                  loading="lazy"
                  class="img-logo"
              >
    </div>
    </div>
    <div class="row">
    <div class="col-12 text-center font-title pb-3 title-head">สมัครสมาชิก Easy</div>
    <div class="col-12">
    <form id="formRegister" class="member font-promotion">
    <label class="title-blog">หมายเลขโทรศัพท์มือถือ</label>
    <div class="form-group mb-2">
    <label for="mobile"><i class="fas fa-mobile-alt input-icon"></i></label>
    <input maxlength="10" type="number" class="form-control input-sm" v-model="tel" placeholder="หมายเลขโทรศัพท์มือถือ" autocomplete="off" ref="tel" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
    </div>
    <hr class="line-gra">

    <label class="title-blog">ชื่อ - สกุล</label>
    <div class="form-group mb-2">
    <label for="fname"><i class="fas fa-user-circle input-icon"></i></label>
    <input type="text" ref="firstname" v-model="firstname" class="form-control input-sm" placeholder="ชื่อ (ไม่ต้องมีคำนำหน้า)" autocomplete="off" required maxlength="50">
    </div>
    <div class="form-group mb-2">
    <label for="lname"><i class="fas fa-user-circle input-icon"></i></label>
    <input type="text" ref="lastname" v-model="lastname" class="form-control input-sm" placeholder="นามสกุล" autocomplete="off" required maxlength="50">
    </div>
    <div class="des-blog">
    <span class="font-white">**ชื่อ-นามสกุล ต้องตรงกับบัญชีธนาคาร</span>
    </div>
    <hr class="line-gra">
    <label class="title-blog">ธนาคาร</label>
    <div class="form-group mb-2">
    <label for="bank_code"><i class="fas fa-university input-icon"></i></label>

    <select class="form-control input-sm"  v-model="bank" ref="bank" required>
        <option value="">- กรุณาเลือก</option>
        <option value="truewallet">True Wallet</option>
        <option value="bankokbank">BBL - ธนาคารกรุงเทพ</option>
        <option value="kbank">KBANK - ธนาคารกสิกรไทย</option>
        <option value="scb">SCB - ธนาคารไทยพาณิชย์</option>
        <option value="tisco">TISCO - ธนาคารทิสโก้</option>
        <option value="ttb">TTB - ทหารไทยธนชาต</option>
        <option value="ktb">KTB - ธนาคารกรุงไทย</option>
        <option value="krungsri">BAY - ธนาคารกรุงศรีอยุธยา</option>
        <option value="kiatnakin">KKP - ธนาคารเกียรตินาคิน</option>
        <option value="gsb">GSB - ธนาคารออมสิน</option>
        <option value="lh">LHBANK - ธนาคารแลนด์ แอนด์ เฮ้าส์</option>
        <option value="uob">UOB - ธนาคารยูโอบี</option>
        <option value="ธนาคารอิสลาม">IBANK - ธนาคารอิสลามแห่งประเทศไทย</option>
        <option value="ghbank">GHB - ธนาคารอาคารสงเคราะห์</option>
        <option value="cimb">CIMB - ธนาคารซีไอเอ็มบีไทย</option>
        <option value="baac">BAAC - ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส)</option>
        <option value="icbc">ICBC - ธนาคารไอซีบีซี (ไทย)</option>
        <option value="standard">STANDARD - ธนาคารสแตนดาร์ดชาร์เตอร์ดไทย</option>
    </select>
    </div>
    <div class="form-group mb-2">
    <label for="bank_accno"><i class="fas fa-credit-card input-icon" style="font-size: 1rem !important;"></i></label>
    <input type="number" class="form-control input-sm" v-model="accountNo" ref="accountNo" maxlength="12" placeholder="เลขที่บัญขีธนาคาร" autocomplete="off" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
    </div>
    <div class="form-group col-sm-8 col-md-12" style="text-align:center" v-if="this.error"><font color="red" size="2">{{this.error}}</font></div>
    <div class="des-blog">
    <span class="font-white">**บัญชีธนาคารที่ใช้ลงทะเบียน ต้องเป็นชื่อบัญชีและเลขที่บัญชีเดียวกับบัญชีที่ใช้สำหรับฝาก-ถอน มิเช่นนั้น จะไม่สามารถถอนเงินได้</span>
    </div>
    <hr class="line-gra">
    <div class="form-group mb-2 text-center" style="margin-top:20px;">
      <button type="button" class="btn-login" @click="submitUser" :disabled="isDisabled"><i class="fas fa-chevron-circle-right"></i> ยืนยันการสมัคร</button>
    </div>
    </form>
    </div>
    <div id="SHOW_ERROR" class="col-12 text-center"></div>
    </div>
    </div>
    <div id="loadPage"></div>

  </div>
</template>

<script>
import "../assets/css/dashboard.css";
import firebase from "firebase/app";
import "firebase/database";
//import moment from "moment-timezone";
const axios = require("axios").default;
import router from "./../router";
import liffService from "@/services/liff";
// @ is an alias to /src
export default {
  name: "Register",
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
    this.getMasterName();
  },
  data() {
    return {
      displayName: "",
      //email: "",
      userId: "",
      pictureUrl: "",
      statusMessage: "",
      firstname: "",
      master: "28",
      agent: "-MP7SM7IVVwFpZg70yXX",
      lastname: "",
      bank: "",
      accountNo: "",
      tel: "",
      mastername: "",
      isDisabled: true,
      loading: false,
      error: "",
      logo :'logo2.png',
      userFriendId:'',
    };
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      this.displayName = profile.displayName ? profile.displayName : "none";
      this.statusMessage = profile.statusMessage
        ? profile.statusMessage
        : "none";
      if (this.userId) {
        const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
        if (user) {
            router.replace("/login");
        }
      }
      this.isDisabled = false;
    },
    async getFriendship() {
      const friend = await window.liff.getFriendship();
      //document.getElementById('friendship').append(friend.friendFlag);
      if (!friend.friendFlag) {
        if (confirm("กดตกลง เพิ่มเพื่อน @ufaeasy888v1 เพื่อรับบริการ และสิทธิพิเศษสมาชิก")) {
          window.liff.openWindow({
             url: `https://lin.ee/9MgANfz`,
          });
          window.liff.closeWindow();
        }
      }
    },
    async getMasterName() {
      const queryString = decodeURIComponent(window.location.search);
      const params = new URLSearchParams(queryString);
      if(params.get("uid"))
          this.master = params.get("uid");
      else if(this.$route.params.id){
          this.master = this.$route.params.id;
      }else{
          this.master = 28;
      }
      if(params.get('userId')){
        this.userFriendId = params.get('userId');
      }else if(params.get('u')){
        this.userFriendId = params.get('userId');
      }else if(this.$route.params.friendId){
        this.userFriendId = this.$route.params.friendId;
      }
      if(this.userFriendId){
        const friend = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userFriendId).once("value")).val();
        const u = friend[Object.keys(friend)[0]];
        const user = (await firebase.database().ref(`/master/${u.master}`).once("value")).val();
        if (user) {
          this.agent = user.agent;
          this.mastername = user.name;
        } else {
          this.agent = "-MP7SM7IVVwFpZg70yXX";
          this.master = "28";
          this.mastername = "UFA Easy888";
        }
      }else
      if (this.master) {
        const user = (await firebase.database().ref(`/master/${this.master}`).once("value")).val();
        if (user) {
          this.agent = user.agent;
          this.mastername = user.name;
        } else {
          this.agent = "-MP7SM7IVVwFpZg70yXX";
          this.master = "28";
          this.mastername = "UFA Easy888";
        }
      }
    },
    async submitUser() {
      if (this.tel == "") {
        this.$refs["tel"].focus();
        return false;
      } else if (this.firstname == "") {
        this.$refs["firstname"].focus();
        return false;
      } else if (this.lastname == "") {
        this.$refs["lastname"].focus();
        return false;
      } else if (this.bank == "") {
        this.$refs["bank"].focus();
        return false;
      } else if (this.accountNo == "") {
        this.$refs["accountNo"].focus();
        return false;
      } else {
        this.isDisabled = true;
        this.loading = true;
        this.error =  "";
        const users = (await firebase.database().ref('users').orderByChild('account_no').equalTo(this.accountNo).once('value')).val();
        if(users == null){
          axios({
            method: "post",
            url: "https://ufaeasy.apifast.xyz/createuser",
            data: {
              agent: this.agent,
              master: this.master.toString(),
              firstname: this.firstname.toString().trim(),
              lastname: this.lastname.toString().trim(),
              bank: this.bank,
              accountNo: this.accountNo,
              tel: this.tel,
              //email: this.email,
              userId: this.userId,
              pictureUrl: (this.pictureUrl)?this.pictureUrl:'',
              statusMessage: (this.statusMessage)?this.statusMessage:'',
              linename: (this.displayName)?this.displayName:'',
              userFriendId:this.userFriendId,
            }
          })
            .then(async response => {
              if (response.data && response.data.status) {
                if (!window.liff.isInClient()) {
                  setTimeout(() => {
                    alert(
                      "ข้อมูลการ Login ของคุณคือ\n\nUsername: " +
                        response.data.username +
                        "\nPassword: " +
                        response.data.password
                    );
                  }, 3000);
                  this.loading = false;
                } else {
                  let check = false;
                  await window.liff.sendMessages([
                    {
                      "type": "flex",
                      "altText": "ขอบคุณที่สมัครสมาชิกกับทางเรา",
                      "contents": {
                          "type": "bubble",
                          "size": "kilo",
                          "hero": {
                            "type": "image",
                            "url": "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2F206101.jpg?alt=media",
                            "size": "full",
                            "aspectRatio": "15:12",
                            "aspectMode": "cover"
                          },
                          "body": {
                            "type": "box",
                            "layout": "vertical",
                            "spacing": "md",
                            "contents": [
                              {
                                "type": "text",
                                "text": "ยินดีต้อนรับสู่",
                                "size": "xl",
                                "weight": "bold",
                                "align": "center",
                                "color": "#fed551"
                              },
                              {
                                "type": "text",
                                "text": "UFAEasy888",
                                "size": "lg",
                                "weight": "bold",
                                "align": "center",
                                "color": "#fed551"
                              },
                              {
                                "type": "box",
                                "layout": "vertical",
                                "spacing": "sm",
                                "contents": [
                                  {
                                    "type": "button",
                                    "action": {
                                      "type": "uri",
                                      "label": "LINE",
                                      "uri": "https://lin.ee/9MgANfz"
                                    },
                                    "style": "primary"
                                  }
                                ]
                              }
                            ],
                            "backgroundColor": "#1B1C1E"
                          }
                        }
                      }
                  ]).catch((error)=>{
                    check = true;
                    alert('โปรดเพิ่มเราเป็นเพื่อน @ufaeasy888v1');
                    window.liff.openWindow({
                      url: `https://lin.ee/9MgANfz`,
                    });
                  });
                  if(!check){
                    this.getFriendship();
                    setTimeout(() => {
                      window.liff.closeWindow();
                    }, 3000);
                  }
                }
              }
            })
            .catch(function(error) {
              console.log(error);
            });
          }else{
            this.$refs["bank"].focus();
            this.loading = false;
            this.error = "โปรดใช้บัญชืออื่น บัญชีนี้มีใช้ในระบบแล้วค่ะ";
            return false;
          }
        }
    }
  }
};
</script>
<style scoped>
@import '../assets/css/all.css';
@import '../assets/css/register.css';
@import '../assets/css/bootstrap.css';
.bodyd{ 
    background-image: url("../assets/images/bgdatabet.png");
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size:100% 100%;
  }
  .member select {
    border-color: #fcde7b;
    background-image: linear-gradient(#080808, #080808);
    background-color:#080808;
    border-radius: 5px;
    text-align: left;
    color: #fcde7b;
    font-size: 1.2rem;
    max-width: 300px;
    width: 100%;
    padding-left: 55px;
    padding-top: 0px;
  }
  .font-white{ color:#c3c3c3!important; }
  .member option{
    width: 300px;
  }
  body div.container-fluid div.row div img.img-logo{
    padding-top: 0px;
    position:absolute;
    max-width: 100px;
    left:20px;
    top:6px;
  }
  .title-blog{ color:#c3c3c3;margin:0px 0px 10px 20px; }
  .des-blog{ color:#c3c3c3!important;padding-left:20px;}
  .line-gra { 
    width:100%;
    border: 0;
      height: 1px;
      background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0));
      margin-top: 10px;
      margin-bottom: 10px;
  }
  form.member div.form-group input.form-control{
    border-radius:5px;
    background-image: linear-gradient(#080808, #080808)
  }
  .title-head{padding-top: 55px;color: #eaeaea;text-shadow: 2px 2px #000000;font-size:1.5rem;}
  .pop-blog{ background: #000000bf;border-radius: 5px;padding: 10px 0px; }
  form.member div.form-group label{ 
    height: 30px;margin-top:0px;
    border:0px;
    border-radius: 0px;
    padding-bottom: 35px;
  }
  .input-sm{ height: 35px; }
  form.member div.form-group button{ font-size:16px; }
  .input-icon{ 
    border-right: 1px solid #a0987a; padding: 4px 10px 2px 0px;color:#fcde7b;
  }
  .border-invild{
    border-color:#ff8200!important; 
  }
  div.alert {
      color: #D4BB66;
  }

@media (min-width:320px)  { /* smartphones, portrait iPhone, portrait 480x320 phones (Android) */ 
  .container-fluid { max-width:420px;margin-top:50px;}
}
@media (min-width:480px)  { /* smartphones, Android phones, landscape iPhone */ 
  .container-fluid { max-width:420px;margin-top:50px;}
}
@media (min-width:600px)  { /* portrait tablets, portrait iPad, e-readers (Nook/Kindle), landscape 800x480 phones (Android) */ 
  .container-fluid { max-width:420px;margin-top:50px;}
}
@media (min-width:801px)  { /* tablet, landscape iPad, lo-res laptops ands desktops */ 
  body{ 
        background-image:url("../assets/images/fullbackground.life.png");
    }
  .container-fluid { max-width:420px;margin-top:50px;}
}
@media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */ 
  body{ 
        background-image:url("../assets/images/fullbackground.life.png");
    }
  .container-fluid { max-width:420px;margin-top:50px;}
}
@media (min-width:1281px) { /* hi-res laptops and desktops */
  body{ 
        background-image:url("../assets/images/fullbackground.life.png");
    } 
  .container-fluid { max-width:420px;margin-top:50px;}
}
</style>
